module.exports = __webpack_public_path__ + "img/aurora-desktop.5b87c229.jpg";